import Button from 'react-bootstrap/Button';
import React from 'react';
import { clearMessage,setMessage } from '../tools/errorhandling';

import {
    triggermails, triggerADW, triggerExpiredIdCardReportTest, triggerExpiredLimosaReportTest, triggerverjaardagenTest
} from "../dbconnector/connector";

const TriggersCaches = (props) => {

    const t = props.translation;
    console.log("in triggersCaches");

    const triggermailsclick = () => {
        triggermails().then(response => {
            if (response.status === 200) {
                console.log("Cache cleared successfully");
            } else {
                console.error("Error clearing cache");
            }
        });
    }

    const triggerADWclick = () => {
        triggerADW().then(response => {
            console.log(response)
            if (response.status === 200) {
                 setMessage("email 'Aangifte der werken rapport' succesvol verzonden")
                console.log("email send successfully");
            } else {
                console.error("Error clearing cache");
            }
        });
    }
    const triggeridexpirationclick = () => {
        triggerExpiredIdCardReportTest().then(response => {
            console.log(response)
            if (response.status === 210) {
                setMessage("email 'id vervallen' succesvol verzonden")
                console.log("email send successfully");
            } else {
                console.error("Error clearing cache");
            }
        });
    }
    const triggerLimosaexpirationclick = () => {
        triggerExpiredLimosaReportTest().then(response => {
            console.log(response)
            if (response.status === 210) {
                setMessage("email 'Limosa vervallen' succesvol verzonden")
                console.log("email send successfully");
            } else {
                console.error("Error limosa report");
            }
        });
    }
        const triggerverjaardagen = () => {
        triggerverjaardagenTest().then(response => {
            console.log(response)
            if (response.status === 210) {
                 setMessage("email 'verjaardagen' succesvol verzonden")
                 
                console.log("email send successfully");
            } else {
                console.error("Error limosa report");
            }
        });
    }
    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <center><Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                        </div>
                    </div>
                </header>
                <div id="return" className="form">
                    <h1 className="title">{t('TriggersCaches')}</h1>
                    <Button onClick={triggermailsclick} type="button" id="cancelButton" class="Savebutton btn btn-primary margin-right" >trigger rooster mails</Button><br></br><br></br>
                    <Button onClick={triggerADWclick} type="button" id="ADWButton" class="Savebutton btn btn-primary margin-right" >trigger vervaldag ADW</Button><br></br><br></br>
                    <Button onClick={triggeridexpirationclick} type="button" id="ADWButton" class="Savebutton btn btn-primary margin-right" >trigger vervaldag id</Button><br></br><br></br>
                    <Button onClick={triggerLimosaexpirationclick} type="button" id="ADWButton" class="Savebutton btn btn-primary margin-right" >trigger vervaldag Limosa</Button><br></br><br></br>
                    <Button onClick={triggerverjaardagen} type="button" id="ADWButton" class="Savebutton btn btn-primary margin-right" >trigger verjaardagen</Button><br></br><br></br>
                </div>

            </div>
        </>
    )
}

export default TriggersCaches;